"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MfaEnrollmentCancelRequestSchema", {
    enumerable: true,
    get: function() {
        return MfaEnrollmentCancelRequestSchema;
    }
});
const _zod = require("zod");
const MfaEnrollmentCancelRequestSchema = _zod.z.object({
    enrollmentToken: _zod.z.string().min(20)
}).strict();
